
import { Component, Prop, Vue } from "vue-property-decorator";

// import isSubscriptionActive from "@/helpers/payment/isSubscriptionActive";
import RouteNames from "@/entities/RouteNames";
import { Company, User } from "@/generated/graphql";

@Component
export default class PaymentRoutesGuard extends Vue {
  @Prop({ type: Object, default: null }) readonly company!: Company | null;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  contentShown: boolean = false;

  created(): void {
    this.checkRedirectConditions();
  }

  updated(): void {
    this.checkRedirectConditions();
  }

  checkRedirectConditions(): void {
    /* Original payment check code
    const latestSubscriptionStatus = this.company?.subscriptions[0]?.status ?? "";
    const withoutSubscription = this.currentUser.subscription_required === false;

    const subscriptionActive = isSubscriptionActive(
      latestSubscriptionStatus,
    );

    if (subscriptionActive || withoutSubscription) {
      this.$router.replace({
        name: RouteNames.DASHBOARD,
      });
    }
    */

    // Always redirect users away from payment pages to dashboard
    // This makes the platform effectively free by preventing access to payment pages
    this.$router.replace({
      name: RouteNames.DASHBOARD,
    });
  }
}
